import { HourTypeModel, HourTypeModelAPI } from '../../../../models';

export const getHourTypesAdapter = (
    responseAPI: HourTypeModelAPI[]
): HourTypeModel[] => {
    return responseAPI
        ? responseAPI.map((hourType) => {
              return {
                  id: hourType.id,
                  name: hourType.name,
                  abbreviature: hourType.abbreviature,
                  isExtraHour: hourType.isExtraHour,
              };
          })
        : [];
};
